import { StationType } from './station-type.enum';
import { StationUsage } from './station-usage.model';

export enum RetrievalStrategy {
    FIFO = 'FIFO', LIFO = 'LIFO'
}

export class Station {
    id: number;
    externalKey: string;
    name: string;
    identifier: string;
    description?: string;
    stationType: StationType;
    used: boolean;
    capacity: number;
    opened: boolean;
    retrievalStrategy: RetrievalStrategy;
    stationUsage = new StationUsage({});


    constructor(station?: any) {
        if (station != null) {
            this.id = station.id;
            this.externalKey = station.externalKey;
            this.name = station.name;
            this.identifier = station.identifier;
            this.description = station.description;
            this.stationType = station.stationType;
            this.used = station.used;
            this.capacity = station.capacity;
            this.retrievalStrategy = station.retrievalStrategy;
        }
    }

}
